var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatewayHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "background",
    style: {
      fill: "#0f0",
      stroke: "#0f0",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7097 0C11.1589 0.0507813 10.7527 0.542969 10.8035 1.09375C10.8542 1.64453 11.3464 2.05078 11.8972 2C16.3386 2 19.8972 5.51172 19.8972 10C19.8933 10.3594 20.0808 10.6953 20.3933 10.8789C20.7058 11.0586 21.0886 11.0586 21.4011 10.8789C21.7136 10.6953 21.9011 10.3594 21.8972 10C21.8972 4.44531 17.405 0 11.8972 0C11.866 0 11.8347 0 11.8035 0C11.7722 0 11.741 0 11.7097 0ZM11.7097 4C11.1589 4.05078 10.7527 4.54297 10.8035 5.09375C10.8542 5.64453 11.3464 6.05078 11.8972 6C13.491 6 14.4285 6.33984 14.991 6.90625C15.5535 7.47266 15.8972 8.41016 15.8972 10C15.8933 10.3594 16.0808 10.6953 16.3933 10.8789C16.7058 11.0586 17.0886 11.0586 17.4011 10.8789C17.7136 10.6953 17.9011 10.3594 17.8972 10C17.8972 8.12109 17.4636 6.56641 16.3972 5.5C15.3308 4.43359 13.7839 4 11.8972 4C11.866 4 11.8347 4 11.8035 4C11.7722 4 11.741 4 11.7097 4ZM4.61596 5.125C3.7058 5.12109 2.93627 5.36719 2.39721 5.90625C0.533929 7.76953 -2.24732 13.3867 3.14721 18.7812C8.0808 23.7148 14.1589 21.3945 16.0222 19.5312C17.5066 18.0469 16.8308 14.8633 14.5847 11.7188C14.1628 12.0586 13.6628 13.1992 13.8972 13.5938C15.0066 15.4688 15.3269 17.1328 14.5535 17.9062C13.3621 19.0977 10.0261 17.7227 7.11596 14.8125C4.2058 11.9023 2.8269 8.57031 4.02221 7.375C4.75268 6.64453 6.27221 6.875 8.02221 7.84375C8.43237 8.07031 9.59252 7.58203 9.92846 7.15625C8.0183 5.85156 6.13159 5.13281 4.61596 5.125ZM11.8972 8C11.0105 8 10.2527 8.57422 9.99096 9.375L7.30346 9.6875C6.97924 9.67578 6.67455 9.85547 6.53002 10.1484C6.38549 10.4375 6.42455 10.7891 6.63159 11.0391C6.84252 11.293 7.17846 11.3984 7.49096 11.3125L10.1785 11.0312C10.3503 11.3164 10.5808 11.5469 10.866 11.7188L10.5847 14.4062C10.4988 14.7188 10.6042 15.0547 10.8581 15.2656C11.1081 15.4727 11.4597 15.5117 11.7488 15.3672C12.0417 15.2227 12.2214 14.918 12.2097 14.5938L12.5222 11.9062C13.323 11.6445 13.8972 10.8867 13.8972 10C13.8972 8.89453 13.0027 8 11.8972 8ZM4.95971 22.0625C3.2644 22.8398 2.11596 24.3086 2.11596 26H13.8035C13.8035 24.957 13.0456 23.7383 12.116 23.2188C11.4792 23.332 10.7996 23.4062 10.116 23.4062C8.29174 23.4062 6.55346 22.9531 4.95971 22.0625Z",
    fill: "#666"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayHighlight);
export default __webpack_public_path__ + "static/media/GatewayHighlight.be61fdab97215d601fadfc36f11bf900.svg";
export { ForwardRef as ReactComponent };